import { InputHTMLAttributes } from 'react';

import { Container, Input } from './TextInput.styles';

type TextInputProps = InputHTMLAttributes<HTMLInputElement> & { icon?: React.ReactElement };

export const TextInput = ({ icon, ...rest }: TextInputProps) => {
  return (
    <Container>
      <Input name="input" {...rest} />
      <label htmlFor="input">{icon ?? null}</label>
    </Container>
  );
};
